import React, { useEffect, useState } from 'react';
import {
  obtenerRecursosAyuda, guardarRecursoAyuda, borrarRecursoAyuda, subirPdfAyuda,
  MODULOS_AYUDA, nombreModulo, youtubeId, miniatura,
} from '../services/ayudaService';
import { useToast } from '../context/ToastContext';
import { mensajeAmigable } from '../utils/errores';

// Panel de la ADMIN para Herramientas y Ayuda: agregar, editar, ocultar y borrar
// videos, guías, plantillas y enlaces. La BD rechaza estos cambios a quien no sea admin.

const TIPOS = [
  { clave: 'video', txt: '▶️ Video', ayudaUrl: 'Enlace de YouTube (súbelo como "No listado")' },
  { clave: 'guia', txt: '📘 Guía', ayudaUrl: 'Enlace del PDF, o súbelo con el botón de abajo' },
  { clave: 'plantilla', txt: '💬 Plantilla', ayudaUrl: '' },
  { clave: 'enlace', txt: '🔗 Enlace', ayudaUrl: 'Dirección completa (https://… o mailto:…)' },
];
const P = 'var(--color-primario,#DB2777)';
const input = { width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };
const nuevo = (tipo = 'video') => ({ tipo, titulo: '', descripcion: '', modulo: tipo === 'video' ? 'inicio' : 'general', url: '', contenido: '', orden: 0, activo: true });

function Formulario({ inicial, onListo, onCancelar }) {
  const { mostrarToast } = useToast();
  const [r, setR] = useState(inicial);
  const [guardando, setGuardando] = useState(false);
  const [subiendo, setSubiendo] = useState(false);
  const tipo = TIPOS.find((t) => t.clave === r.tipo);
  const cambiar = (campo) => (e) => setR((x) => ({ ...x, [campo]: e.target.value }));

  const errorDe = () => {
    if (!r.titulo.trim()) return 'Escribe un título.';
    if (r.tipo === 'video' && !youtubeId(r.url)) return 'Pega un enlace de YouTube válido.';
    if ((r.tipo === 'guia' || r.tipo === 'enlace') && !r.url.trim()) return 'Falta el enlace.';
    if (r.tipo === 'plantilla' && !r.contenido.trim()) return 'Escribe el texto de la plantilla.';
    return '';
  };
  const error = errorDe();

  const guardar = async (e) => {
    e.preventDefault();
    if (error) { mostrarToast(error, 'error'); return; }
    setGuardando(true);
    try { await guardarRecursoAyuda(r); mostrarToast('Guardado. Ya lo ven todos los negocios.', 'success'); onListo(); }
    catch (err) { mostrarToast(mensajeAmigable(err), 'error'); }
    finally { setGuardando(false); }
  };

  const subir = async (e) => {
    const archivo = e.target.files?.[0];
    e.target.value = '';
    if (!archivo) return;
    setSubiendo(true);
    try { const url = await subirPdfAyuda(archivo); setR((x) => ({ ...x, url })); mostrarToast('PDF subido.', 'success'); }
    catch (err) { mostrarToast(err?.message || mensajeAmigable(err), 'error'); }
    finally { setSubiendo(false); }
  };

  const id = r.tipo === 'video' ? youtubeId(r.url) : null;
  return (
    <form onSubmit={guardar} style={{ background: '#fff', border: '1px solid #EEE7FB', borderRadius: '14px', padding: '16px', display: 'grid', gap: '12px', marginBottom: '16px' }}>
      <b>{r.id ? 'Editar recurso' : 'Nuevo recurso'}</b>
      {!r.id && (
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
          {TIPOS.map((t) => (
            <button key={t.clave} type="button" onClick={() => setR(nuevo(t.clave))}
              style={{ padding: '7px 12px', borderRadius: '999px', fontWeight: 700, cursor: 'pointer', border: `1px solid ${r.tipo === t.clave ? P : '#E5E7EB'}`, background: r.tipo === t.clave ? P : '#fff', color: r.tipo === t.clave ? '#fff' : '#4B5563' }}>{t.txt}</button>
          ))}
        </div>
      )}
      <label style={{ display: 'grid', gap: '4px', fontSize: '13px', fontWeight: 700 }}>Título
        <input style={input} value={r.titulo} maxLength={160} onChange={cambiar('titulo')} placeholder={r.tipo === 'video' ? 'Cómo registrar una venta' : ''} />
      </label>
      <label style={{ display: 'grid', gap: '4px', fontSize: '13px', fontWeight: 700 }}>Descripción corta (opcional)
        <input style={input} value={r.descripcion || ''} maxLength={600} onChange={cambiar('descripcion')} />
      </label>
      {r.tipo !== 'enlace' && (
        <label style={{ display: 'grid', gap: '4px', fontSize: '13px', fontWeight: 700 }}>{r.tipo === 'video' ? '¿De qué módulo es?' : 'Tema'}
          <select style={input} value={r.modulo} onChange={cambiar('modulo')}>
            {MODULOS_AYUDA.map((m) => <option key={m.clave} value={m.clave}>{m.nombre}</option>)}
          </select>
          {r.tipo === 'video' && <span style={{ fontWeight: 400, color: '#6B7280' }}>Aparece en "¿Cómo funciona?" dentro de ese módulo.</span>}
        </label>
      )}
      {r.tipo !== 'plantilla' && (
        <label style={{ display: 'grid', gap: '4px', fontSize: '13px', fontWeight: 700 }}>Enlace
          <input style={input} value={r.url || ''} maxLength={1000} onChange={cambiar('url')} inputMode="url" placeholder="https://" />
          <span style={{ fontWeight: 400, color: '#6B7280' }}>{tipo?.ayudaUrl}</span>
        </label>
      )}
      {r.tipo === 'guia' && (
        <label className="k-btn-soft" style={{ justifySelf: 'start', cursor: 'pointer' }}>
          {subiendo ? 'Subiendo…' : '⬆️ Subir PDF'}
          <input type="file" accept="application/pdf" onChange={subir} disabled={subiendo} style={{ display: 'none' }} />
        </label>
      )}
      {id && <img src={miniatura(id)} alt="Vista previa del video" style={{ width: '220px', borderRadius: '10px' }} />}
      {r.tipo === 'plantilla' && (
        <label style={{ display: 'grid', gap: '4px', fontSize: '13px', fontWeight: 700 }}>Texto del mensaje
          <textarea style={{ ...input, minHeight: '110px', fontFamily: 'inherit' }} value={r.contenido || ''} maxLength={4000} onChange={cambiar('contenido')}
            placeholder="¡Hola, [Nombre]! …" />
          <span style={{ fontWeight: 400, color: '#6B7280' }}>Pon entre [corchetes] lo que cada negocio debe cambiar.</span>
        </label>
      )}
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
        <label style={{ display: 'flex', gap: '6px', alignItems: 'center', fontSize: '14px' }}>
          Orden <input style={{ ...input, width: '80px' }} type="text" inputMode="numeric" value={r.orden}
            onChange={(e) => setR((x) => ({ ...x, orden: e.target.value.replace(/[^\d]/g, '') }))} />
        </label>
        <label style={{ display: 'flex', gap: '6px', alignItems: 'center', fontSize: '14px' }}>
          <input type="checkbox" checked={r.activo} onChange={(e) => setR((x) => ({ ...x, activo: e.target.checked }))} /> Visible para todos
        </label>
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button type="submit" disabled={guardando || subiendo}
          style={{ padding: '10px 18px', borderRadius: '8px', border: 'none', background: P, color: '#fff', fontWeight: 700, cursor: 'pointer' }}>{guardando ? 'Guardando…' : 'Guardar'}</button>
        <button type="button" className="k-btn-soft" onClick={onCancelar}>Cancelar</button>
      </div>
    </form>
  );
}

export default function AdminAyudaView({ onVolver }) {
  const { mostrarToast } = useToast();
  const [lista, setLista] = useState(null);
  const [editando, setEditando] = useState(null);
  const [filtro, setFiltro] = useState('video');

  const cargar = () => obtenerRecursosAyuda({ forzar: true }).then(setLista).catch((e) => mostrarToast(mensajeAmigable(e), 'error'));
  useEffect(() => { cargar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const borrar = async (r) => {
    if (!window.confirm(`¿Borrar "${r.titulo}" para siempre? Si solo quieres esconderlo, desmarca "Visible para todos".`)) return;
    try { await borrarRecursoAyuda(r.id); mostrarToast('Borrado.', 'success'); cargar(); }
    catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const visibles = (lista || []).filter((r) => r.tipo === filtro);
  return (
    <div className="k-page">
      <div className="k-page-head">
        <h2 className="k-page-title">🧰 Admin · Herramientas y Ayuda</h2>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {!editando && <button onClick={() => setEditando(nuevo(filtro))} style={{ padding: '8px 14px', borderRadius: '10px', border: 'none', background: P, color: '#fff', fontWeight: 800, cursor: 'pointer' }}>+ Agregar</button>}
          <button onClick={onVolver} className="k-btn-soft">← Volver</button>
        </div>
      </div>
      <p style={{ margin: '0 0 14px', color: '#6B7280', fontSize: '14px' }}>
        Lo que agregues aquí lo ven todos los negocios en "Herramientas y Ayuda". Sube los videos a YouTube como <b>No listado</b> y pega el enlace.
      </p>

      {editando && <Formulario key={editando.id || editando.tipo} inicial={editando} onCancelar={() => setEditando(null)} onListo={() => { setEditando(null); cargar(); }} />}

      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
        {TIPOS.map((t) => {
          const n = (lista || []).filter((r) => r.tipo === t.clave).length;
          return (
            <button key={t.clave} onClick={() => setFiltro(t.clave)}
              style={{ padding: '7px 12px', borderRadius: '999px', fontWeight: 700, cursor: 'pointer', border: `1px solid ${filtro === t.clave ? P : '#E5E7EB'}`, background: filtro === t.clave ? '#FDF2F8' : '#fff', color: '#374151' }}>
              {t.txt} ({n})
            </button>
          );
        })}
      </div>

      {!lista ? <p style={{ color: '#6B7280' }}>Cargando…</p>
        : !visibles.length ? <p style={{ color: '#6B7280' }}>Todavía no hay nada aquí. Usa "+ Agregar".</p>
        : (
          <div style={{ display: 'grid', gap: '8px' }}>
            {visibles.map((r) => (
              <div key={r.id} style={{ display: 'flex', gap: '12px', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', background: '#fff', border: '1px solid #EEE7FB', borderRadius: '12px', padding: '10px 14px', opacity: r.activo ? 1 : 0.6 }}>
                <div style={{ minWidth: 0, flex: '1 1 260px' }}>
                  <b>{r.titulo}</b>{!r.activo && <span style={{ marginLeft: '8px', fontSize: '12px', color: '#B91C1C' }}>Oculto</span>}
                  <div style={{ fontSize: '12.5px', color: '#6B7280' }}>{r.tipo !== 'enlace' ? nombreModulo(r.modulo) : r.url} · orden {r.orden}</div>
                </div>
                <div style={{ display: 'flex', gap: '6px' }}>
                  <button className="k-btn-soft" onClick={() => setEditando({ ...r, descripcion: r.descripcion || '', url: r.url || '', contenido: r.contenido || '' })}>Editar</button>
                  <button className="k-btn-soft" style={{ color: '#B91C1C' }} onClick={() => borrar(r)}>Borrar</button>
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
